var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('core-list-view-page', {
    attrs: {
      "fetch-items": _vm.fetchDashboards,
      "fetchErrorMessage": 'Dashboards.snacks.fetchFailed',
      "external-fetch-params": {
        accountFilterIsReady: _vm.accountFilterIsReady,
        selectedAccountIds: _vm.selectedAccountIds
      },
      "table-headers": _vm.tableHeaders,
      "headline": _vm.$i18n_t('Dashboards.listView.title'),
      "subtitle": _vm.$i18n_t('Dashboards.listView.subtitle'),
      "has-search-bar": true,
      "show-beta-badge": _vm.$i18n_t('Dashboards.listView.closedBeta'),
      "row-href": item => `/dashboards/${item.id}`,
      "delete-item": _vm.deleteDashboard,
      "delete-item-snack-message": _vm.$i18n_t('Dashboards.listView.snacks.deleteItem.success'),
      "delete-item-error-snack-message": error => _vm.$i18n_t('Dashboards.listView.snacks.deleteItem.error', {
        error
      }),
      "empty-state-icon": "fal fa-user-chart",
      "empty-state-title": _vm.$i18n_t('Dashboards.listView.emptyState.title'),
      "empty-state-description": _vm.$i18n_t('Dashboards.listView.emptyState.description'),
      "empty-state-button-label": _vm.$i18n_t('Dashboards.listView.emptyState.button'),
      "hide-editing-buttons": !_vm.hasEditPermissions
    },
    on: {
      "button:create": function ($event) {
        _vm.showCreateDialog = true;
      },
      "button:edit": item => _vm.$router.push(`/dashboards/${item.id}?edit=true`),
      "click:empty-state": function ($event) {
        _vm.showCreateDialog = true;
      }
    },
    scopedSlots: _vm._u([{
      key: "buttons-after",
      fn: function () {
        return [_c('core-account-filter', {
          attrs: {
            "multiple": ""
          },
          on: {
            "change": _vm.onAccountFilterChange,
            "ready": function ($event) {
              _vm.accountFilterIsReady = true;
            }
          }
        })];
      },
      proxy: true
    }])
  }), _c('upsert-dashboard-dialog', {
    on: {
      "save": _vm.onSave
    },
    model: {
      value: _vm.showCreateDialog,
      callback: function ($$v) {
        _vm.showCreateDialog = $$v;
      },
      expression: "showCreateDialog"
    }
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };